import { Trans } from 'react-i18next';
import EventIcon from '@mui/icons-material/Event';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { ROUTES } from '@routes/routes';
import { NotificationPresenter } from '@notifications/interfaces';
import { CompetitionSessionTomorrowParticipantReminderNotificationData } from './interfaces';

const isCompetitionSessionTomorrowParticipantReminderPayload = (
  payload: unknown
): payload is CompetitionSessionTomorrowParticipantReminderNotificationData => {
  if (typeof payload !== 'object' || payload === null) {
    return false;
  }

  return (
    'competitionName' in payload &&
    typeof payload.competitionName === 'string'
  );
};

export const competitionSessionTomorrowParticipantReminderPresenter: NotificationPresenter<CompetitionSessionTomorrowParticipantReminderNotificationData> =
  {
    type: 'competition-session-tomorrow-participant-reminder',
    icon: EmojiEventsIcon,
    badgeIcon: EventIcon,
    isPayload: isCompetitionSessionTomorrowParticipantReminderPayload,
    label: (payload, t) =>
      t(
        'notifications:types.competition-session-tomorrow-participant-reminder',
        {
          competitionName: payload.competitionName,
        }
      ),
    message: (payload) => (
      <Trans
        i18nKey="notifications:menu.competition-session-tomorrow-participant-reminder"
        values={{
          competitionName: payload.competitionName,
        }}
        components={{
          bold: <strong />,
        }}
      />
    ),
    path: (payload) => {
      if (!payload.competitionSlug) {
        return null;
      }

      return `${ROUTES.portal.competitions.details(payload.competitionSlug)}?tab=sessions`;
    },
  };
